import typography from "../typographyTheme";

export default {
  root: {
    ...typography.body1,
  },
};
